import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import urlJoin from 'url-join'

const isBrowser = typeof window !== 'undefined' && window

const currentLocationContext = React.createContext()

export const CurrentLocationProvider = currentLocationContext.Provider
CurrentLocationProvider.propTypes = {
	value: PropTypes.string.isRequired,
}

export function useCurrentLocation() {
	if (isBrowser) {
		return `${urlJoin(window.location.origin, window.location.pathname)}`
	}

	return useContext(currentLocationContext)
}
